export default __webpack_public_path__ + "static/media/guide.6f3f88e2.svg";